/* KARHDIR upsells: independent of Shrine scripts. Cart insertion is handled by Ignite product-form.js. */
(() => {
  const money = (cents, root) => {
    let options = { currency: 'USD', locale: 'en-US' };
    try { options = { ...options, ...JSON.parse(root.querySelector('[data-upsell-money-config]')?.textContent || '{}') }; } catch(e) {}
    try { return new Intl.NumberFormat(options.locale, { style: 'currency', currency: options.currency }).format(cents / 100); }
    catch(e) { return (cents / 100).toFixed(2); }
  };
  function getItems(root) {
    return [...root.querySelectorAll('[data-upsell-item]')].flatMap(row => {
      const check = row.querySelector('[data-upsell-check]');
      const variant = row.querySelector('[data-upsell-variant]');
      const chosen = variant?.tagName === 'SELECT' ? variant.selectedOptions[0] : variant;
      const quantity = row.querySelector('[data-upsell-quantity]');
      if (!check?.checked || check.disabled || !chosen || chosen.dataset.available !== 'true') return [];
      const id = Number(variant.value);
      const q = Math.max(1, Math.min(99, Number.parseInt(quantity.value, 10) || 1));
      return Number.isSafeInteger(id) && id > 0 ? [{ id, quantity:q }] : [];
    });
  }
  function refresh(root) {
    root.querySelectorAll('[data-upsell-item]').forEach(row => {
      const variant = row.querySelector('[data-upsell-variant]');
      const chosen = variant.tagName === 'SELECT' ? variant.selectedOptions[0] : variant;
      const available = chosen?.dataset.available === 'true';
      const check = row.querySelector('[data-upsell-check]');
      check.disabled = !available;
      if (!available) check.checked = false;
      row.classList.toggle('is-selected', Boolean(check.checked && available));
      row.classList.toggle('is-unavailable', !available);
      row.querySelector('[data-upsell-price]').textContent = money(Number(chosen?.dataset.price || 0), root);
    });
    let total = 0;
    root.querySelectorAll('[data-upsell-item]').forEach(row => {
      if (!row.querySelector('[data-upsell-check]').checked) return;
      const variant = row.querySelector('[data-upsell-variant]');
      const chosen = variant.tagName === 'SELECT' ? variant.selectedOptions[0] : variant;
      total += Number(chosen?.dataset.price || 0) * Math.max(1, Math.min(99, Number.parseInt(row.querySelector('[data-upsell-quantity]').value, 10) || 1));
    });
    const el = root.querySelector('[data-upsell-total]'); if (el) el.textContent = money(total, root);
  }
  document.addEventListener('change', e => {
    const root = e.target.closest('[data-product-upsells]');
    if (root) refresh(root);
  });
  document.addEventListener('click', e => {
    const row = e.target.closest('[data-upsell-item]');
    const root = row?.closest('[data-product-upsells]');
    if (!root) return;

    const button = e.target.closest('[data-upsell-increment],[data-upsell-decrement]');
    if (button) {
      const input = row.querySelector('[data-upsell-quantity]');
      if (!input) return;
      const delta = button.hasAttribute('data-upsell-increment') ? 1 : -1;
      input.value = Math.max(1, Math.min(99, (Number.parseInt(input.value, 10) || 1) + delta));
      refresh(root);
      return;
    }

    // Native form controls retain their own behavior; card clicks toggle only this item.
    if (e.target.closest('input, label, button, select, option, textarea')) return;
    const check = row.querySelector('[data-upsell-check]');
    if (!check || check.disabled) return;
    check.checked = !check.checked;
    refresh(root);
  });
  document.addEventListener('keydown', e => {
    const row = e.target.closest('[data-upsell-item]');
    if (!row || e.target !== row || !['Enter', ' '].includes(e.key)) return;
    const check = row.querySelector('[data-upsell-check]');
    if (!check || check.disabled) return;
    e.preventDefault();
    check.checked = !check.checked;
    refresh(row.closest('[data-product-upsells]'));
  });
  document.querySelectorAll('[data-product-upsells]').forEach(refresh);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-product-upsells]').forEach(refresh));
  window.KarhdirProductUpsells = { getItems };
})();
